var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"min-height":"100%"},attrs:{"id":"app"}},[_c('v-app',{staticClass:"cppsbg",attrs:{"id":"ecpl"}},[_c('v-container',[_c('router-view')],1),_c('ecpl-footer')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }